import { MenuState } from '@features/main/interfaces/main.interfaces';
import { ProcesoDivision } from '@interfaces/firestore-documents.interfaces';
import { Chip, Theme, Typography, useMediaQuery } from '@mui/material';
import clsx from 'clsx';
import useProcessesTableStyles from './ProcessesTable.styles';

interface Props {
	data: ProcesoDivision[];
	id: string;
	menuState: MenuState;
	searchedProcess: string;
}

const ProcessesTable: React.FC<Props> = ({ data, id, menuState, searchedProcess }) => {
	const classes = useProcessesTableStyles();

	// Breakpoints
	const isExtraLargeScreen = useMediaQuery(
		(theme: Theme) => theme.breakpoints.up('xl') && theme.breakpoints.down(1655)
	);

	const isLargeScreen = useMediaQuery((theme: Theme) => theme.breakpoints.down('xl'));
	const isSmallScreen = useMediaQuery((theme: Theme) => theme.breakpoints.down('lg'));

	return (
		<div className={classes.container} id={id}>
			{data.length > 0 ? (
				<table
					className={clsx(classes.root, {
						[classes.rootExtraLargeMenuSmall]:
							isExtraLargeScreen && menuState === 'small',
						[classes.rootLargeMenuBig]: isLargeScreen && menuState === 'big',
						[classes.rootSmallMenuBig]: isSmallScreen && menuState === 'big',
					})}
				>
					<thead>
						<tr>
							<th></th>
							<th></th>
							<th>Consecutivos</th>
							<th></th>
							<th></th>
							<th></th>
						</tr>
						<tr>
							<th>ID</th>
							<th>Nombre</th>
							<th>Prefijo</th>
							<th>Inicial</th>
							<th>Final</th>
							<th>Actual</th>
						</tr>
					</thead>
					<tbody>
						{data.map((d, i) => (
							<tr
								className={clsx({
									disabled: !d.estado,
									searched:
										d.estado &&
										searchedProcess.length > 0 &&
										(d.nombre_proceso.toLowerCase().includes(searchedProcess) ||
											d.id_proceso_text.includes(searchedProcess)),
								})}
								id={`${id}-${d.id_proceso}`}
								key={`${id}-${d.id_proceso}-${i}`}
							>
								<td>{d.id_proceso_text}</td>
								<td>{d.nombre_proceso}</td>
								<td>
									<Chip label={d.prefijo_consecutivo} variant="outlined" />
								</td>
								<td>
									<Chip label={d.consecutivo_desde} variant="outlined" />
								</td>
								<td>
									<Chip label={d.consecutivo_hasta} variant="outlined" />
								</td>
								<td>
									<Chip label={d.consecutivo_actual} variant="outlined" />
								</td>
							</tr>
						))}
					</tbody>
				</table>
			) : (
				<Typography fontFamily="Montserrat" fontSize={14} style={{ marginTop: 24 }}>
					No hay procesos creados
				</Typography>
			)}
		</div>
	);
};

export default ProcessesTable;
